import React, { useEffect, useState } from "react";
import API from "../api";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./AttendanceHistory.css";
export default function AttendanceHistory() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const today = new Date().toISOString().split("T")[0];

  const [day, setDay] = useState(today);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const isDaySelected = !!day;
  const isRangeSelected = !!fromDate || !!toDate;
  const [username, setUsername] = useState("");

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    API.get(`/attendance/history/${id}`).then((res) => {
      setHistory(res.data);
    });
  }, [id]);

  useEffect(() => {
    if (day) {
      setFromDate("");
      setToDate("");
    }
  }, [day]);

  useEffect(() => {
    if (fromDate || toDate) {
      setDay("");
    }
  }, [fromDate, toDate]);


  const formatTime = (t) => {
    if (!t) return "--";
    return new Date(`2000-01-01T${t}`).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit"
    });
  };
  // Format date like: Nov 26th, 2025
  function formatDate(dateString) {
    const date = new Date(dateString);

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }

  const getHours = (inT, outT) => {
    if (!inT || !outT) return '00:00:00';

    const inTime = new Date(`2000-01-01T${inT}`);
    let outTime = new Date(`2000-01-01T${outT}`);

    // If out_time < in_time, add 12 hours (PM shift)
    if (outTime < inTime) {
      outTime = new Date(outTime.getTime() + 12 * 60 * 60 * 1000);
    }

    const diffMs = outTime - inTime;
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((diffMs % (1000 * 60)) / 1000);

    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  const filteredHistory = history.filter((item) => {
    const itemDate = new Date(item.date).toISOString().split("T")[0];

    if (day) {
      return itemDate === day;
    }

    if (fromDate && toDate) {
      return itemDate >= fromDate && itemDate <= toDate;
    }

    return true;
  });

  useEffect(() => {
    API.get(`/attendance/history/${id}`).then((res) => {
      setHistory(res.data);

      if (res.data.length > 0) {
        setUsername(res.data[0].user_name); // ✅ use this
      }
      else {
        setUsername("Unknown User"); // or keep blank
      }
    });
  }, [id]);

  return (


    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
        <Sidebar />
      </div>
      <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
        <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="main-content">
          <div className="container-fluid py-4">
            <div className="dashboard-title">
              <img
                src="/Dashboard-Red-64.png"
                alt="dashboard"
                className="dashboard-icon"
              />
              <span>Dashboard</span>
            </div>
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <h2 style={{ margin: 0 }}>Time History</h2>

                <button
                  onClick={() => navigate("/AdminDashboard/AttendanceDashboard")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ed3338",
                    color: "#fff",
                    border: "none",
                    padding: "6px 19px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    marginRight: "12px"
                  }}
                >
                  ← Back
                </button>
              </div>
              <div
                className="filter-row"
               style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center", // ✅ IMPORTANT (fix alignment)
                  marginBottom: 20,
                }}
              >

                {/* LEFT SIDE → Username */}
                <div style={{ fontSize: "18px", fontWeight: "600" }}>
                  👤 {username || "User"}
                </div>


                <div className="filter-row" style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>

                  {/* DAY */}
                  <div className="filter-group">
                    <label className="filter-label">Select Day</label>
                    <input
                      type="date"
                      value={day}
                      disabled={isRangeSelected}
                      onChange={(e) => setDay(e.target.value)}
                      className="filter-input"
                    />
                  </div>

                  {/* FROM */}
                  <div className="filter-group">
                    <label className="filter-label">From Date</label>
                    <input
                      type="date"
                      value={fromDate}
                      disabled={isDaySelected}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="filter-input"
                    />
                  </div>

                  {/* TO */}
                  <div className="filter-group">
                    <label className="filter-label">To Date</label>
                    <input
                      type="date"
                      value={toDate}
                      min={fromDate}
                      disabled={isDaySelected}
                      onChange={(e) => setToDate(e.target.value)}
                      className="filter-input"
                    />
                  </div>
                </div>
              </div>

              <div className="history-grid">
                {filteredHistory.map((day, index) => {
                  const colors = [
                    "rgba(252,125,19,0.1)", // fc7d13
                    "rgba(75,174,80,0.1)",  // 4bae50
                    "rgba(32,149,243,0.1)", // 2095f3
                    "rgba(237,51,56,0.1)",  // ed3338
                  ];

                  return (
                    <div
                      key={index}
                      className="history-card"
                      style={{ background: colors[index % colors.length] }}
                    >
                      <div className="history-date">{formatDate(day.date)}</div>

                      {day.status === "leave" ? (
                        <>
                          <div className="history-hours">❌ 0 hrs</div>
                          <div className="history-status leave">Leave</div>
                          <div className="history-reason">{day.reason}</div>
                        </>
                      ) : day.status === "half-day" ? (
                        <>
                          <div className="history-hours">⏳ Half Day</div>
                          <div className="history-status half">{day.reason}</div>
                        </>
                      ) : (
                        <>
                          <div className="history-hours">
                            🕒 {getHours(day.in_time, day.out_time)}
                          </div>
                          <div className="history-time">
                            {formatTime(day.in_time)} — {formatTime(day.out_time)}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  );
}
